// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3QnoM","select":"Header_select__2B1SB","clinic":"Header_clinic__2Qpm-"};